import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { API_URL } from "../pages/utils/utils";

export default function SeoLinksSection() {
  const [seoLinks, setSeoLinks] = useState([]);
  const [loading, setLoading] = useState(true);
  const companyId = 1; // Hardcoded as per requirement

  useEffect(() => {
    fetchSeoLinks();
  }, []);

  const fetchSeoLinks = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${API_URL}seo/index_seo_links/${companyId}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });

      // Check content type before parsing
      const contentType = response.headers.get("content-type");
      const isJson = contentType && contentType.includes("application/json");

      if (response.ok && isJson) {
        try {
          const data = await response.json();
          if (data.status && data.data) {
            const links = Array.isArray(data.data) ? data.data : [];
            
            // Fetch pages for each link
            const linksWithPages = await Promise.all(
              links.map(async (link) => {
                try {
                  const pagesResponse = await fetch(
                    `${API_URL}seo/index_seo_pages_links/${link.id}`,
                    {
                      method: "GET",
                      headers: {
                        "Content-Type": "application/json",
                        Accept: "application/json",
                      },
                    }
                  );

                  const pagesContentType = pagesResponse.headers.get("content-type");
                  const pagesIsJson = pagesContentType && pagesContentType.includes("application/json");

                  if (pagesResponse.ok && pagesIsJson) {
                    try {
                      const pagesData = await pagesResponse.json();
                      if (pagesData.status && pagesData.data) {
                        return {
                          ...link,
                          seo_pages: Array.isArray(pagesData.data) ? pagesData.data : [],
                        };
                      }
                    } catch (jsonError) {
                      console.error(`Error parsing JSON for link ${link.id}:`, jsonError);
                    }
                  }
                  return {
                    ...link,
                    seo_pages: [],
                  };
                } catch (error) {
                  console.error(`Error fetching pages for link ${link.id}:`, error);
                  return {
                    ...link,
                    seo_pages: [],
                  };
                }
              })
            );

            setSeoLinks(linksWithPages);
          }
        } catch (jsonError) {
          console.error("Error parsing JSON response:", jsonError);
          const textResponse = await response.text();
          console.error("Response text:", textResponse.substring(0, 200));
        }
      } else if (response.ok && !isJson) {
        console.error("Non-JSON response received from SEO links API");
        const textResponse = await response.text();
        console.error("Response text:", textResponse.substring(0, 200));
      }
    } catch (error) {
      console.error("Error fetching SEO links:", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return null; // Don't show anything while loading
  }

  if (!seoLinks || seoLinks.length === 0) {
    return null; // Don't show section if no links
  }

  return (
    <section 
      className="seo-links-section py-5" 
      style={{ 
        // backgroundImage: "url(images/background_pattern.png)",
        // backgroundColor: "#d70015",
        position: "relative"
      }}
    >
      <div className="container">
        <div className="row">
          {seoLinks.map((link, index) => (
            <div 
              key={link.id} 
              className="col-lg-3 col-md-6 col-sm-12 mb-4 mb-lg-0"
            >
              <div 
                className="seo-link-column h-100" 
                style={{ 
                  padding: "20px 15px"
                }}
              >
                <div style={{ position: "relative", marginBottom: "25px" }}>
                  <h3 
                    className="mb-0" 
                    style={{
                      fontSize: "20px",
                      fontWeight: "600",
                      paddingBottom: "15px",
                      marginBottom: 0,
                      color:"#d70015"
                    }}
                  >
                    {link.title}
                  </h3>
                  <div 
                    style={{
                      height: "2px",
                      width: "50px",
                      background: "#fff",
                      marginTop: "0"
                    }}
                  />
                </div>
                {link.seo_pages && link.seo_pages.length > 0 ? (
                  <ul className="list-unstyled" style={{ margin: 0, padding: 0, listStyle: "none" }}>
                    {link.seo_pages
                      .filter((page) => page.slug && page.seo_page_title) // Only show pages with valid slug and title
                      .map((page) => (
                        <li 
                          key={page.id || page.slug} 
                          style={{ 
                            marginBottom: "15px",
                            lineHeight: "1.8",
                            display: "block",
                            width: "100%"
                          }}
                        >
                          <Link
                            to={`/seo/${encodeURIComponent(page.slug)}`}
                            className="text-decoration-none d-block"
                            style={{ 
                              fontSize: "15px",
                              transition: "all ease-in-out 0.3s",
                              display: "block",
                              opacity: 0.95,
                              color:"#000000",
                              marginBottom: "5px"
                            }}
                            onMouseEnter={(e) => {
                              e.target.style.color = "#d70015";
                              e.target.style.opacity = "1";
                              e.target.style.paddingLeft = "5px";
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.color = "#d70015";
                              e.target.style.opacity = "0.95";
                              e.target.style.paddingLeft = "0";
                            }}
                          >
                            {page.seo_page_title}
                          </Link>
                          <br />
                        </li>
                      ))}
                  </ul>
                ) : (
                  <p 
                    style={{ 
                      opacity: 0.7,
                      fontSize: "14px",
                      margin: 0,
                      color:"#d70015"
                    }}
                  >
                    No pages available
                  </p>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
